import React from 'react'
import { Button } from 'react-bootstrap'

const styles = {
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr 85px',
    columnGap: '20px',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '8px',
    padding: '8px 10px',
    backgroundColor: 'rgba(254, 226, 226, 0.4)',
  },
  alertWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  titleWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  title: {
    padding: 0,
    margin: '0 5px 0 0',
    color: '#dc3545',
  },
  text: {
    padding: 0,
    margin: 0,
    color: '#dc3545',
  },
  icon: {
    color: '#dc3545',
  },
}

const IframeBudgetAlert = ({ alertText, alertTitle, openCampaign }) => {
  return (
    <>
      {alertText && (
        <div style={styles.container}>
          <div style={styles.alertWrapper}>
            <div style={styles.titleWrapper}>
            <div className="me-1">
              <i className="ri-alert-fill" style={styles.icon}></i>
            </div>
            <b style={styles.title}>{alertTitle}:</b>
            </div>
            <p style={styles.text}>{alertText}</p>
          </div>
          <Button variant="outline-danger" onClick={openCampaign}>
            Fix Issue
          </Button>
        </div>
      )}
    </>
  )
}

export default IframeBudgetAlert
